import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "../screens/dashboard/Dashboard";
import LoginScreen from "../auth/login/LoginScreen";
import ForgotPassword from "../auth/forgot/ForgotPassword";
import PageNotFound from "../screens/error/PageNotFound";
import LeasePage from "../screens/lease/LeasePage";
import PasswordReset from "../auth/password-reset/PasswordReset";
import CustomersPage from "../screens/customer/customersPage";
import SingleLease from "../screens/lease/SingleLease";
import ProductPage from "../screens/Products/ProductPage";
import AddProducts from "../screens/Products/Sections/AddProducts";
import SingleProduct from "../screens/Products/Sections/SingleProduct";
import Apprenticeship from "../screens/apprenticeship/Apprenticeship";
import SingleApprenticeship from "../screens/apprenticeship/SingleApprenticeship";
import Information from "../screens/customer/Sections/Information";
import Investment from "../screens/customer/Sections/Investment";
import Transactions from "../screens/customer/Sections/Transactions";
import FinancialInfo from "../screens/customer/Sections/FinancialInfo";
import SingleTransaction from "../screens/customer/Sections/SingleTransaction";
import UsersPage from "../screens/users/UserPage";
import AddUser from "../screens/users/sections/AddUser";
import SingleUser from "../screens/users/sections/SingleUser";
import EducationPage from "../screens/education/EducationPage";
import AuthRoute from "./AuthRoute";
import ProtectedRoute from "./ProtectedRoute";
import PrivateRoute from "./PrivateRoute";
import Unauthorized from "../screens/error/Unauthorized";
import AddVideo from "../screens/education/Sections/AddVideo";
import AddAudio from "../screens/education/Sections/AddAudio";
import AddBook from "../screens/education/Sections/AddBook";
import SingleEducation from "../screens/education/Sections/SingleEducation";
import Profile from "../screens/profile/Profile";
import TravelAdvance from "../screens/travelAdvance/TravelAdvance";
import SingleTVA from "../screens/travelAdvance/SingleTVA";
import Parameters from "../screens/parameters/Parameters";
import AddParameter from "../screens/parameters/Sections/AddParameter";
import InputVariables from "../screens/parameters/Sections/InputVariables";
import EditParameter from "../screens/parameters/Sections/EditParameter";
import Account from "../screens/accounts/Account";
import AFRequestInformation from "../screens/accounts/Sections/AFRequestInformation";
import AFreport from "../screens/accounts/Sections/AFreport";
import Scheme from "../screens/scheme/Scheme";
import AddMember from "../screens/scheme/sections/AddMember";
import SingleScheme from "../screens/scheme/sections/SingleScheme";
import Logistics from "../screens/logistics/Logistics";
import SingleLogistics from "../screens/logistics/SingleLogistics";
import CreateAsset from "../screens/lease/CreateAsset";
import CreateFinanceRequests from "../screens/apprenticeship/CreateFinanceRequests";

function RouterPage() {
	return (
		<Router>
			<Routes>
				<Route element={<AuthRoute />}>
					<Route path='/login' element={<LoginScreen />} />
					<Route path='/forgot-password' element={<ForgotPassword />} />
					<Route path='/reset-password' element={<PasswordReset />} />
				</Route>

				<Route element={<ProtectedRoute />}>
					<Route exact path='/' element={<Dashboard />} />

					<Route element={<PrivateRoute service={["lease"]} />}>
						<Route exact path='/lease/:category?' element={<LeasePage />}>
							<Route exact path=':id' element={<SingleLease />} />
						</Route>
						<Route path='/lease/create_asset/:current_tab?' element={<CreateAsset />} />
					</Route>

					<Route element={<PrivateRoute service={["apprenticeship"]} />}>
						<Route exact path='/apprenticeship/:category?' element={<Apprenticeship />}>
							<Route exact path=':id' element={<SingleApprenticeship />} />
						</Route>
						<Route path='/apprenticeship/create_request' element={<CreateFinanceRequests />} />
					</Route>

					<Route element={<PrivateRoute service={["products"]} />}>
						<Route exact path='/products' element={<ProductPage />}>
							<Route exact path=':category' element={<AddProducts />} />
							<Route exact path=':category/:productId' element={<SingleProduct />} />
						</Route>
					</Route>

					<Route element={<PrivateRoute service={["education"]} />}>
						<Route exact path='/education/:category?' element={<EducationPage />}>
							<Route exact path=':id' element={<SingleEducation />} />
						</Route>
						<Route path='/education/addvideo' element={<AddVideo />} />
						<Route path='/education/addbook' element={<AddBook />} />
						<Route path='/education/addaudio' element={<AddAudio />} />
						{/* <Route path="/education/addContent" */}
					</Route>

					<Route element={<PrivateRoute service={["travel-advance"]} />}>
						<Route exact path='/travel-advance/:category?' element={<TravelAdvance />}>
							<Route exact path=':id' element={<SingleTVA />} />
						</Route>
					</Route>

					<Route element={<PrivateRoute service={["customer"]} />}>
						<Route exact path='/customer' element={<CustomersPage />}>
							<Route path=':id/general' element={<Information />} />
							<Route path=':id/financial' element={<FinancialInfo />} />
							<Route path=':id/transactions' element={<Transactions />} />
							<Route path=':id/investments' element={<Investment />} />
							<Route path=':id/transactions/:transactionid' element={<SingleTransaction />} />
						</Route>
					</Route>

					<Route element={<PrivateRoute service={["users"]} />}>
						<Route path='/users' element={<UsersPage />} />
						<Route path='/users/adduser' element={<AddUser />} />
						<Route path='/users/:id' element={<SingleUser />} />
					</Route>

					<Route element={<PrivateRoute service={["logistics"]} />}>
						<Route exact path='/logistics/:category?' element={<Logistics />}>
							<Route exact path=':id/:filter?' element={<SingleLogistics />} />
						</Route>
					</Route>

					<Route element={<PrivateRoute service={["account"]} />}>
						<Route exact path='/account' element={<Account />}>
							<Route path=':id' element={<AFRequestInformation />} />
							<Route path=':id/report' element={<AFreport />} />
						</Route>
					</Route>

					<Route element={<PrivateRoute service={["scheme"]} />}>
						<Route path='scheme/addmember' element={<AddMember />} />
						<Route exact path='/scheme' element={<Scheme />}>
							<Route exact path=':id' element={<SingleScheme />} />
						</Route>
					</Route>

					<Route element={<PrivateRoute service={["parameters"]} />}>
						<Route path='/parameters' element={<Parameters />} />
						<Route path='/parameters/add-new' element={<AddParameter />} />
						<Route path='/parameters/edit/:id' element={<EditParameter />} />
						<Route path='/parameters/input-variables' element={<InputVariables />} />
					</Route>

					<Route path='/profile' element={<Profile />} />
				</Route>

				{/* End of protected Routes  */}
				<Route path='/unauthorized' element={<Unauthorized />} />
				<Route path='*' element={<PageNotFound />} />
			</Routes>
		</Router>
	);
}

export default RouterPage;
